import { render, staticRenderFns } from "./SystemTypeInput.vue?vue&type=template&id=1cdd1982&scoped=true"
import script from "./SystemTypeInput.vue?vue&type=script&lang=js"
export * from "./SystemTypeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdd1982",
  null
  
)

export default component.exports